import Vue from '_lib/_vue'
import EntryConfig from './core/entry'
import WebpDirective from '_lib/plugin/webp-directive.js'
import "./core/style/common.less"


Vue.use(WebpDirective)

import HeyboxReport from '_lib/plugin/heybox-report'
Vue.use(HeyboxReport)

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

import { HbSwitch } from '@heybox-components/heybox-ui'
Vue.use(HbSwitch)

Vue.config.productionTip = false 

new Vue(EntryConfig).$mount('#app')
